import { render, staticRenderFns } from "./StorageQuestionEdit.vue?vue&type=template&id=095498ce&scoped=true&"
import script from "./StorageQuestionEdit.vue?vue&type=script&lang=js&"
export * from "./StorageQuestionEdit.vue?vue&type=script&lang=js&"
import style0 from "./StorageQuestionEdit.vue?vue&type=style&index=0&id=095498ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095498ce",
  null
  
)

export default component.exports